export default __webpack_public_path__ + "static/media/Analysis-cuate 1.12989158.svg";